import { Injectable } from '@angular/core';
import Swal, { SweetAlertIcon } from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class SwalService {
  private generalBody = {
    showConfirmButton: true,
    showCancelButton: true,
    confirmButtonColor: '#4b2cdc',
    cancelButtonColor: '#FA5A5A',
    reverseButtons: true,
  };

  private generalConfirm = {
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
  };

  public fire(title: string, text: string, icon: SweetAlertIcon) {
    Swal.fire({ title, text, icon });
  }

  public fireBasicConfirm(
    title: string,
    text: string,
    html = '',
    icon: SweetAlertIcon
  ): any {
    const notificationBody: any = {
      title,
      text,
      html,
      icon,
      ...this.generalBody,
      ...this.generalConfirm,
    };
    return Swal.fire(notificationBody);
  }

  public fireCustomConfirm(
    title: string,
    text: string,
    html = '',
    icon: SweetAlertIcon,
    confirmButtonText: string,
    cancelButtonText: string
  ): any {
    const notificationBody: any = {
      title,
      text,
      html,
      icon,
      confirmButtonText,
      cancelButtonText,
      ...this.generalBody,
    };
    return Swal.fire(notificationBody);
  }
}
